export function sendNewRelicError(message, details) {
  if (!global.newrelic) {
    return;
  }

  global.newrelic.addPageAction('error', {
    source: 'media-manager-sdk',
    message: message,
    details: details
  });
}